import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { BlockedIp } from '@shared/services/logs/logs.service';
import { CountryService } from '@shared/services/country.service';
import { OrganizationSiteService } from '@shared/services/organization-site.service';
import { ToastrService } from '@shared/services/toastr.service';
import { toCidr } from '@shared/utils/data-utils';
import { NgxDatatableModule } from '@siemens/ngx-datatable';
import { NgIf, NgStyle } from '@angular/common';
import { NumberFormatPipe } from '@shared/pipe/filter.pipe';
import * as pager from '@shared/pager';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-blocked-ips-table',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './blocked-ips-table.component.html',
  styleUrl: './blocked-ips-table.component.scss',
  imports: [NgxDatatableModule, NgIf, NgStyle, NumberFormatPipe, TranslatePipe],
})
export class BlockedIPsTableComponent {
  @Input() topBlockedIps: BlockedIp[];
  @Input() print: boolean = false;

  @Output() clickCountry = new EventEmitter<BlockedIp>();
  @Output() clickIp = new EventEmitter<BlockedIp>();

  constructor(
    public translate: TranslateService,
    public countries: CountryService,
    private siteApi: OrganizationSiteService,
    private toastr: ToastrService,
  ) {
  }

  async ngOnInit() {
    await this.countries.init();
  }

  async addIpException(event: IpExceptionEvent) {
    const ipExceptions = await firstValueFrom(this.siteApi.getIpExceptions(event.site));
    const ip = toCidr(event.ip);
    if (!ipExceptions.map(ipException => ipException.ip).includes(ip)) {
      this.siteApi.setIpExceptions(event.site, [...ipExceptions, { ip }]).subscribe({
        next: () => this.translate.instant('WhitelistedIPAdded'),
        error: (err) => this.toastr.error(err.status == 409 ? 'AlreadyExists' : 'EnregistrementEchoue'),
      });
    }
  }

  protected readonly pager = pager;
}

export interface IpExceptionEvent {
  ip: string;
  site: string;
}
